module.exports = __webpack_public_path__ + "static/media/logo.c40d8223.png";